

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Shift } from '@/models/admin/shift';
import { Base } from '@/components/common/base';
import { shiftService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class ShiftSavePage extends Base {
  public stores: any[];
  public shift: Shift = {
    id: 0,
    name: '',
    startTime: '',
    endTime: '',
  };
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public disableSubmitButton: boolean = false;
  public created(): void {
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.shifts',
        params: { storeId: this.storeId.toString() },
      });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid || this.disableSubmitButton) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.submitShift();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('shifts.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('shifts.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public async mounted(): Promise<void> {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'shifts');

    this.storeId = Number(this.$route.params.storeId);
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (this.$route.params.id) {
      this.getShift(this.$route.params.id);
    }
  }

  public validateShift(): Vue & { validate: () => boolean } {
    return this.$refs.shiftForm as Vue & { validate: () => boolean };
  }

  public async submitShift(): Promise<void> {
    if (this.validateShift().validate()) {
      var validateRes = this.$validator.errors.items.length > 0;
      if (validateRes) {
        this.showAlert(false, 'Please Enter Valid Details');
        return;
      }

      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        if (this.$route.params.id) {
          await shiftService.updateShift(this.shift, this.storeId);
          this.showAlert(true, this.$t('shifts.alertUpdateShift'));
          this.$router.push({
            name: 'admin.shifts',
            params: { storeId: this.storeId.toString() },
          });
        } else {
          await shiftService.saveShift(this.shift, this.storeId);
          this.showAlert(true, this.$t('shifts.alertSaveShift'));
          this.$router.push({
            name: 'admin.shifts',
            params: { storeId: this.storeId.toString() },
          });
        }
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }
  public async getShift(id: string): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const shift = await shiftService.getShift(Number(id), this.storeId);
      this.shift = shift;
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$t('shifts.shiftFields.name') as string,
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Name', v)
          ]
        },
      },
      {
        key: 'startTime',
        type: 'v-alynk-timepicker',
        required: true,
        templateOptions: {
          counter: 500,
          label: this.$t('shifts.shiftFields.startTime') as string,
          required: true,
          disabled: false,
          time: true,
          loading: false,
          rules: [
            v => this.required('Start Time', v)
          ]
        },
      },
      {
        key: 'endTime',
        type: 'v-alynk-timepicker',
        required: true,
        templateOptions: {
          counter: 500,
          label: this.$t('shifts.shiftFields.endTime') as string,
          required: true,
          disabled: false,
          time: true,
          loading: false,
          rules: [
            v => this.required('End Time', v)
          ]
        },
      },
      {
        key: 'description',
        type: 'v-alynk-textarea',
        required: false,
        templateOptions: {
          counter: 500,
          label: this.$t('shifts.shiftFields.description') as string,
          required: false,
          disabled: false,
          loading: false,
        },
      },
    ];
  }
}
